import { CasinoGameInfo, MenuPosition } from "../http/protocol";


export enum NavigationActionTypes {
    SHOW_USER_NAVIGATION = "@navigation/user/show",
    SET_ACTIVE_TAB = "@navigation/user/tab",
    SHOW_SPORTSBOOK ="@navigation/sportsbook/show",
    SHOW_SIDE_MENU ="@navigation/showsidemenu",
    IS_LANDING_PAGE = "@navigation/isLandingPage",
    SHOW_POKER ="@navigation/poker/show",
    POKER_LOADING_COMPLETE = "@navigation/poker/loaded",
    ADD_PATH = "@navigation/add-path",
    CAPTCHA_LOADED = "@navigation/captcha-loaded",
    SELECT_MOBILE_PREVIEW = "@navigation/select/mobile/preview",
    SET_SIDEMENU_POSITION = "@navigation/set/sidemenu/position",

}

export type NavigationActions =
    | { type : NavigationActionTypes.SHOW_USER_NAVIGATION, show : boolean}
    | { type : NavigationActionTypes.SET_ACTIVE_TAB, tab : number}
    | { type : NavigationActionTypes.SHOW_SPORTSBOOK, show : boolean}
    | { type : NavigationActionTypes.SHOW_SIDE_MENU, show : boolean}
    | { type : NavigationActionTypes.IS_LANDING_PAGE, show : boolean}
    | { type : NavigationActionTypes.SHOW_POKER, show : boolean}
    | { type : NavigationActionTypes.POKER_LOADING_COMPLETE, complete : boolean}
    | { type : NavigationActionTypes.ADD_PATH, path : string}
    | { type : NavigationActionTypes.CAPTCHA_LOADED }
    | { type : NavigationActionTypes.SELECT_MOBILE_PREVIEW, game: CasinoGameInfo }
    | { type : NavigationActionTypes.SET_SIDEMENU_POSITION, position: MenuPosition }



export const selectMobilePreviewGame = (game? : CasinoGameInfo) => (
    { type : NavigationActionTypes.SELECT_MOBILE_PREVIEW, game : game}
)

export const captchaLoaded = () => (
    { type : NavigationActionTypes.CAPTCHA_LOADED }
);
export const addPath = (path : string) => (
    {type: NavigationActionTypes.ADD_PATH, path: path}
)
export const toggleShowUserNavigation = (show : boolean) => (
    { type : NavigationActionTypes.SHOW_USER_NAVIGATION, show : show }
);

export const setActiveTab = (tab : number) => (
    { type : NavigationActionTypes.SET_ACTIVE_TAB, tab : tab }
);

export const toggleShowSportsbook = (show : boolean) => {
    return {type : NavigationActionTypes.SHOW_SPORTSBOOK, show : show}
}

export const toggleShowPoker = (show : boolean) => {
    return {type : NavigationActionTypes.SHOW_POKER, show : show}
}

export const showSideMenu = (show : boolean) => {
    return {type : NavigationActionTypes.SHOW_SIDE_MENU, show : show}
}

export const setPokerLoadingComplete = (complete : boolean) =>  {
    return { type : NavigationActionTypes.POKER_LOADING_COMPLETE, complete : complete };
}

export const isLandingPage = (show : boolean) => {
    return {type : NavigationActionTypes.IS_LANDING_PAGE, show : show}
}

// Call in settings ( initial dispatch )
export const setSideMenuPosition = (position : MenuPosition) => {
    return {type : NavigationActionTypes.SET_SIDEMENU_POSITION, position : position}
}


export function setMenuStateInLocalStorage(menuState: boolean, menuPosition: MenuPosition | undefined ){
    if(menuPosition == MenuPosition.FIXED){
        localStorage.setItem('menustate', menuState ? 'on' : 'off')
    }
}

